import { Picker } from 'antd-mobile';
import { useState } from 'react';
import './CountryCodeSelect.css';

const COUNTRY_CODES = [
  { label: '🇲🇾  Malaysia  (+60)', value: '+60', flag: '🇲🇾', country: 'Malaysia' },
  { label: '🇸🇬  Singapore  (+65)', value: '+65', flag: '🇸🇬', country: 'Singapore' },
];

export function normalizeSupportedCountryCode(value) {
  return value === '+65' ? '+65' : '+60';
}

/** 明确呈现为国家码选择器，避免被误认为可输入手机号的文本框。 */
export default function CountryCodeSelect({ value, onChange, compact = false }) {
  const [visible, setVisible] = useState(false);
  const normalized = normalizeSupportedCountryCode(value);
  const selected = COUNTRY_CODES.find((item) => item.value === normalized) || COUNTRY_CODES[0];

  return (
    <>
      <button
        type="button"
        className={`country-code-select${compact ? ' country-code-select--compact' : ''}`}
        onClick={() => setVisible(true)}
        aria-label={`Country code: ${selected.country} ${selected.value}. Tap to change.`}
      >
        <span className="country-code-select__flag" aria-hidden="true">{selected.flag}</span>
        <span className="country-code-select__identity">
          <span className="country-code-select__caption">Country code</span>
          <span className="country-code-select__country">{selected.country}</span>
        </span>
        <strong className="country-code-select__value">{selected.value}</strong>
        <span className="country-code-select__chevron" aria-hidden="true">▾</span>
      </button>
      <Picker
        columns={[COUNTRY_CODES]}
        visible={visible}
        value={[normalized]}
        onClose={() => setVisible(false)}
        onConfirm={(next) => {
          onChange?.(normalizeSupportedCountryCode(next?.[0]));
          setVisible(false);
        }}
      />
    </>
  );
}
